import React from "react";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {Link} from 'react-router-dom';


const MakerSpace = () =>{
  
  return (
    <div className="LearningSpace">
      <section className="inner-banner banner-align">
        <img className="img-fluid" src="./assets/img/innerbanner/explore.jpg" alt="" />
      </section>
      <section className='information-common' id="ExploreLibrary">
        <div className='container'>
          <div className='information-content'>
            <h2>Using the Library/Explore</h2>
            <p>The following collaborative spaces are available at the library.</p>
          </div>
          <Row>
                <Col lg={5} sm={6}>
                <div className="floating-Side-wrap">
                    <div className="floating-Side">
                        <div className="right-tab-collab">
                        <div className="flex-column nav nav-pills">
                                <div className="nav-item">
                                    <Link as={Link} to="/CollaborativeWorkingAndLearningSpaces" className='nav-link'>
                                    Collaborative Working and Learning Spaces
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/ComputerAndTechnology" className='nav-link'>
                                    Computer And Technology
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/PrintingScanningAndPhotocopying" className='nav-link'>
                                    Printing Scanning And Photocopying
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/LibraryService" className='nav-link'>
                                    Library Service
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/MakerSpace" className='nav-link active'>
                                    Maker Space
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </Col>
                <Col lg={7} sm={6}>
                <div className="collaboration-hover">
                    <img className="img-fluid" src="./assets/img/learningspaces/marker-space.jpg" alt="" />
                    <p>HU Library and its spaces promote a “Do It Yourself” (DIY) attitude towards learning. To promote interdisciplinary learning, innovation, and collaboration, a maker space is available at the library. Maker equipment is provided for generating ideas and prototypes. Maker workshops are also organized for building skills. Apart from workshops, maker items, and stationery are also issued to individuals and groups of students for putting their creativity to work.</p>
                </div>
                </Col>
            </Row>
        </div>
      </section>


    </div>
  );
}
export default MakerSpace;